import React, { useState, useCallback } from 'react'
import { Formik, Form, Field } from 'formik'
import { useSelector } from 'react-redux'
import {
  accountsSelector,
  carouselCurrentItemSelector,
  getFeatureListSelector,
} from '../../../../selectors'
import RequestService from '../../../../services/requests.service'
import { CardLoadSchema } from '../../../../schemas/requests'
import InputError from '../../../../components/InputError/InputError'
import NeoOTP from '../../../../components/FormComponents/NeoOTP'
import NeoSuccess from '../../../../components/FormComponents/NeoSuccess'
import NeoLoader from '../../../../components/FormComponents/NeoLoader'
import NeoButton from '../../../../components/NeoButton/NeoButton'
import NeoInput from '../../../../components/NeoInput/NeoInput'
import { useHistory } from 'react-router-dom'
import NumberFormat from 'react-number-format'
import LayoutWithAccountCard from '../../../../layout/Layout/layout-account-card'
import { ACCOUNT_SUB_MENUS, REQUEST_MENUS } from '../../../../layout/Layout/menu-names'
import AccountDisplay from '../../../../components/account-display/account-display'
import { VALIDATION_MESSAGES } from '../../../../utils/translation-constants'
import { useTranslation } from 'react-i18next'

const parentMenus = REQUEST_MENUS.filter((ele) => ele.key !== 'DEBIT_CARD')
const menuDetails = REQUEST_MENUS.filter((ele) => ele.key === 'DEBIT_CARD')[0]
const parentMenuDetails = ACCOUNT_SUB_MENUS.filter((ele) => ele.key === 'REQUESTS')[0]

function CardLoad() {
  const { t } = useTranslation()
  const [stage, setStage] = useState(1)
  const [loading, setLoading] = useState(false)
  const accounts = useSelector(accountsSelector)
  const [accountList, setAccountList] = useState([])
  const [cardVerify, setCardVerify] = useState(true)
  const history = useHistory()
  const [formValues, setFormValues] = useState({
    cardNumber: '',
    currency: '',
    amount: '',
  })
  const [currency, setCurrency] = useState()
  const [otp, setOTP] = useState('')
  const [randomKey, setRandomKey] = useState('')
  const [cardLoading, setCardLoading] = useState(false)
  const [message, setMessage] = useState('')
  const currentAccountDetail = useSelector(carouselCurrentItemSelector)
  const featureList = useSelector(getFeatureListSelector)
  const featureDetails = featureList['CARD_LOAD']

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm()
      case 2:
        return renderConfirmation()
      case 3:
        return <NeoOTP onSubmit={cardLoadConfirm} otp={otp} setOTP={setOTP} />
      case 4:
        return <NeoSuccess message={message} linkPath='/requests' />
      default:
        return <renderForm />
    }
  }

  const submitCardLoadForm = useCallback(
    async (data) => {
      try {
        setCardLoading(true)
        if (data.amount === '') {
          const response = await RequestService.getCardAccounts({
            cardNumber: data.cardNumber,
          })
          setCardVerify(false)
          setAccountList(response.accountList)
          setCardLoading(false)
        } else {
          setCardLoading(true)
          setFormValues(data)
          setCardLoading(false)
          setStage(2)
        }
      } catch (err) {
        setCardLoading(false)
      }
    },
    [currency],
  )

  const cardLoadConfirm = useCallback(async () => {
    try {
      setLoading(true)
      const response = await RequestService.confirmCardLoad({
        accountId: accountList.find((x) => x.currency === formValues.currency).account,
        amount: parseFloat(formValues.amount),
        cardNumber: formValues.cardNumber,
        cardAccountCurrency: formValues.currency,
        otp,
        randomKey,
        sourceAccount: formValues.accountNumber,
        sourceAccountBranch: accounts.find((v) => v.accountNo === formValues.accountNumber).brnCode,
        sourceAccountCurrency: formValues.currency,
      })
      setMessage(response.message)
      setLoading(false)
      setStage(4)
    } catch (err) {
      setLoading(false)
    }
  }, [formValues, otp, randomKey, accounts])

  const confirmClick = useCallback(async () => {
    setLoading(true)
    try {
      const response = await RequestService.verifyCardLoad({
        amount: formValues.amount,
        cardNumber: formValues.cardNumber,
        sourceAccount: formValues.accountNumber,
        sourceAccountBranch: accounts.find((v) => v.accountNo === formValues.accountNumber).brnCode,
        sourceAccountCurrency: formValues.currency,
      })
      if (response.otpEnable) {
        setLoading(false)
        setRandomKey(response.requestId)
        setStage(3)
      } else {
        await cardLoadConfirm()
        setLoading(false)
      }
    } catch (err) {
      setLoading(false)
      setStage(1)
    }
  }, [formValues, accounts, cardLoadConfirm])

  function renderForm() {
    return (
      <div>
        <div className='heading-style'>Card Load Request </div>
        <AccountDisplay currentAccountDetail={currentAccountDetail} />
        <Formik
          initialValues={formValues}
          enableReinitialize
          validationSchema={CardLoadSchema}
          onSubmit={submitCardLoadForm}>
          {({ isSubmitting, handleChange, handleBlur, errors, touched, values }) => (
            <Form>
              {/* <div className='form-group my-2'>
            <NeoInput
              mode='select'
              text='Account Number'
              name='accountNumber'
              onChange={(text) => {
                handleChange(text)
                setSelectedAccount(text.target.value)
              }}
              onBlur={(e) => {
                handleBlur(e)
                setSelectedAccount(e.target.value)
              }}
              list={accounts}
              keyValue='accountNo'
            />
            <InputError text={errors.accountNumber} touched={touched.accountNumber} />
          </div> */}
              <div className='row'>
                <div className='form-group col-9'>
                  <NeoInput text='Card Number' onChange={handleChange} name='cardNumber' />
                  <InputError text={errors.cardNumber} touched={touched.cardNumber} />
                </div>
                <div className='form-group col-3 mt-auto ml-auto'>
                  {cardLoading ? (
                    <NeoLoader />
                  ) : (
                    <NeoButton
                      mode={'newDesign'}
                      type='button'
                      className='btn btn-neo'
                      onClick={() => submitCardLoadForm(values)}
                      text='Verify'
                    />
                  )}
                </div>
              </div>
              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    mode='select'
                    text='To Currency'
                    name='currency'
                    onChange={(e) => {
                      setCurrency(e.target.value)
                      handleChange(e)
                    }}
                    onBlur={(e) => {
                      handleBlur(e)
                      setCurrency(e.target.value)
                    }}
                    list={accountList}
                    keyValue='currency'
                  />

                  <InputError text={errors.currency} touched={touched.currency} />
                </div>
                <div className='form-group col-12'>
                  <NeoInput
                    text='Amount'
                    text='Card Number'
                    onChange={handleChange}
                    name='amount'
                  />
                  <InputError text={errors.amount} touched={touched.amount} />
                </div>
              </div>
              <div className='mt-3'>
                {isSubmitting && !formValues.amount === null ? (
                  <NeoLoader />
                ) : (
                  <NeoButton
                    mode={'newDesign'}
                    type='submit'
                    disabled={cardVerify || isSubmitting}
                    text='Submit'
                  />
                )}
              </div>
              <div className='back-cancel-style' onClick={() => history.goBack()}>
                {' '}
                Cancel{' '}
              </div>
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  function renderConfirmation() {
    return (
      <div className='d-flex flex-column confirmation'>
        <h3>Confirm Card Load</h3>
        <AccountDisplay currentAccountDetail={currentAccountDetail} />
        <div>
          <h6 className='label'>Card Number</h6>
          <h6 className='value'>{formValues.cardNumber}</h6>
        </div>
        <div>
          <h6 className='label'>Currency</h6>
          <h6 className='value'>{formValues.currency}</h6>
        </div>
        <div>
          <h6 className='label'>Amount</h6>
          <h6 className='value'>
            <NumberFormat
              value={formValues.amount}
              displayType={'text'}
              thousandSeparator={true}
              prefix={''}
              fixedDecimalScale={true}
              decimalScale={2}
              allowEmptyFormatting
            />
          </h6>
        </div>
        <div className='mt-5'>
          <NeoButton mode={'newDesign'} type='button' text='Confirm' onClick={confirmClick} />
          <div className='back-cancel-style' onClick={() => setStage(1)}>
            {' '}
            Back{' '}
          </div>
        </div>
      </div>
    )
  }

  return (
    <LayoutWithAccountCard
      title={parentMenuDetails.title}
      description={parentMenuDetails.desc}
      parentMenuList={parentMenus}
      icon={parentMenuDetails.icon}>
      {featureDetails[currentAccountDetail['accountType']] !== 'N' && (
        <div className='new-design-form-style'>{renderSwitch()}</div>
      )}

      {featureDetails[currentAccountDetail['accountType']] === 'N' && (
        <div className='no-data-found'>{t(VALIDATION_MESSAGES.NO_ACCESS)}</div>
      )}
    </LayoutWithAccountCard>
  )
}

export default React.memo(CardLoad)
